import { cloneDeep } from 'lodash'

import { Component, Prop, Watch } from 'vue-property-decorator'

import MxEditorComponent from '@/mixins/editor-component'
import { EditBase } from '@/store/editor/types'
import { EditorField } from '@/store/entity/types'

@Component
export default class extends MxEditorComponent {
  public fieldInitialized = false // This component had it's state initialized
  public value: any = ''
  public originalValue: any = ''
  public unwatch: (() => void) | undefined
  public unwatchOriginal: (() => void) | undefined
  // TODO: I think this maybe needs to go to EditorField and we figure out the consequences!?
  @Prop()
  public editorField!: EditorField // the field we're editing

  get isRequired() {
    return this.editorField?.IsRequired
  }

  get displayName() {
    return this.editorField.DisplayName
  }

  get displayDescription() {
    return this.editorField.DisplayDescription
  }

  get editorType() {
    return this.editorField?.EditorType
  }

  get propertyName() {
    return this.editorField?.EntityProperty.PropertyName
  }

  // for a field!
  get idProperty() {
    return this.idProperties[0]
  }

  // public findId(entityObject: EntityObject = this.editorField.Section.Editor.EntityObject) {

  // }
  // // this will go upwards until it finds something with an Id. This may not be perfect, but it gets the PcnCatalogNumber
  // public findIdProperties(entityObject: EntityObject = this.editorField.Section.Editor.EntityObject) {
  //   if (this.editorField.Section.Editor.EntityObject.idProperties.length === 0 && entityObject?.parentEntityProperty?.parentEntityObject) {
  //     return this.getIdProperties(entityObject.parentEntityProperty.parentEntityObject)
  //   } else {
  //     return entityObject.idProperties
  //   }
  // }

  get idProperties() {
    return this.editorField.Section.Editor.EntityObject.idProperties
  }

  get title() {
    return this.editorField.PropertyEditor?.EntityObject.titleProperties.map(c => this.obj[c.PropertyName]).join(':') || ''
  }
  // entry: EditBase

  get idTitle() {
    return this.idProperties.map(c => this.obj[c.PropertyName]).join(', ') || ''
  }

  // TODO: get id passing an object!"?"
  get id() {
    return this.idProperties.map(c => this.obj[c.PropertyName]).join(':') || ''
  }

  // propertyIdFields or make getPropertyIds?
  public getIds(entry: EditBase) {
    return this.idProperties?.map(c => entry[c.PropertyName]) || []
  }

  mounted() {
    if (this.readOnly) {
      this.initializeValue()
    } else {
      this.intializeField()
    }
  }

  // TODO: this is a work-around for the OrderBy field - but it's needed elsewhere
  @Watch('obj.OrderBy')
  public objOrderByChanged() {
    this.fieldInitialized = false
    this.intializeField()
  }

  @Watch('obj.loading', { deep: true })
  public objChanged(newLoading: boolean, oldLoading: boolean) {
    if (this.obj.isNone || newLoading) return
    // const { idProperty } = this

    // the object changed, we should re-initialize this field
    // Q: is this.getId too expensive?

    // note: some fields are ready with this Watch
    // and some are ready with the editorLoading watch? why?

    // - this is needed for the Model fields for some reason, but not the ModelDetail fields?
    if (!newLoading && oldLoading) { // if it was loading and now it's not, then we're ready
      this.fieldInitialized = false
      this.intializeField()
    }
    // if (idProperty) {
    //   if (newObj[idProperty.PropertyName] !== oldObj[idProperty.PropertyName]) {
    //     this.fieldInitialized = false
    //     this.intializeField()
    //     // return
    //   }
    // }

    // note: The old and new object have the same value (ref issue with child objects)
    // - but the whole reason we're doing this is to update the value, because that has the old value!
    // - but wait, why is it not a change now!
    // - this mainly happens when we apply the changes from an existing ChangeRequest

    // TODO: ok, so the value wasn't set yet - and the ids were the same...
    // if (oldObj.isNone || oldObj.loading) return

    // if (newObj[propertyName] !== oldObj[propertyName]) {
    //   this.initializeValue()
    //   this.valueUpdated(this.value)
    // }
  }

  @Watch('editorLoading')
  public editorLoadingChanged(editorLoading: boolean) {
    // whenever the editor finishes loading, we check if we're intialized or not
    // - this is needed for the ModelDetail fields for some reason
    // TODO: for some reason error is undefined because the obj isn't anything
    if (!editorLoading && (!this.obj?.error)) {
      this.fieldInitialized = false
      this.intializeField()
    }
  }

  public intializeField() {
    this.stopWatch()
    const { defaultValue, propertyName, obj, originalObj, setChanged } = this
    // this.stopWatch()
    // only initialize if we aren't initialized and not loading (we will try again when editLoading changes)
    if (this.editorLoading || this.fieldInitialized) { return }
    this.fieldInitialized = true
    this.initializeValue() // TODO: figure out why this is needed? (again)
    // TODO: not always text!

    if (originalObj) {
      this.originalValue = cloneDeep(originalObj[propertyName])
    } else {
      this.originalValue = obj !== undefined ? cloneDeep(obj[propertyName]) : defaultValue
    }
    this.$emit('update-original-value', this.originalValue)

    this.unwatch = this.$watch('obj.' + propertyName, this.watchValue)
    this.unwatchOriginal = this.$watch('originalObj.' + propertyName, this.watchOriginalValue)

    setChanged(this.value)
  }

  public initializeValue() {
    // TODO: how many times?
    const { defaultValue, editorField, propertyName, parentColumn, parentObj, obj, getColumnValid } = this
    // TODO: OK, so this works after I hit save somehow?
    // not intialized with a value or something?
    // yeah - it doesn't have a value when I first come here? WHY?

    this.value = propertyName && obj[propertyName] !== undefined ? obj[propertyName] : defaultValue

    this.isValid = getColumnValid({ obj, parentObj, editorField, parentColumn, value: this.value })
  }

  // TODO: this is what was breaking in column lists!
  // - it doesn't know it's a list!
  public valueUpdated(value: any) {
    if (this.fieldInitialized) {
      // was passing: obj: EntityBase, column: LayoutPropertyColumn,
      // but that's local, right?
      const { editorField, originalValue } = this
      this.fieldValueUpdated(editorField, value, originalValue)
    }
  }

  // triggered if the value was updated outside of the field component
  public watchValue() {
    const { editorField, obj, parentObj, parentColumn, propertyName, defaultValue, getColumnValid, setChanged, onValidated } = this
    this.value = obj[propertyName] !== undefined ? obj[propertyName] : defaultValue

    // because we were updated outside, we need to make sure to set our valid and changed states
    setChanged(this.value)

    this.isValid = getColumnValid({ obj, parentObj, editorField, parentColumn, value: this.value })
    onValidated(this.isValid)

    // Q: do we need to do this since it WAS updated aleady
    // this.$emit('update-value', obj, editorField, value)

    // TODO: is this right? stop watching after first time?
    // if (editorField.EditorType === 'order' || editorField.EditorType === 'modelassociations') {
    //   this.stopWatch()
    // }
  }

  public watchOriginalValue() {
    const { propertyName, obj, originalObj, defaultValue } = this
    if (originalObj) {
      this.originalValue = cloneDeep(originalObj[propertyName])
    } else {
      this.originalValue = obj !== undefined ? cloneDeep(obj[propertyName]) : defaultValue
    }

    // TODO: I do not know if removing this line is the correct things to do
    // setChanged(this.value)
    this.$emit('update-original-value', this.originalValue)
  }

  public setChanged(value: any) {
    const { setFieldChanged, editorField, originalValue } = this
    setFieldChanged(editorField, value, originalValue)
  }

  public stopWatch() {
    if (this.unwatch) {
      this.unwatch()
    }
    if (this.unwatchOriginal) {
      this.unwatchOriginal()
    }
  }

  get fieldDisabled() {
    return this.isFieldDisabled(this.editorField)
  }

  get defaultValue() {
    let defaultValue: any = this.editorField?.DefaultValue
    if (this.editorType === 'checkbox') {
      defaultValue = (defaultValue === 'true')
    }
    return defaultValue
  }

  // return null if no validation necessary
  get valid() {
    return this.editorField.Validations === undefined || this.editorField.Validations.length === 0 ? null : this.isValid
  }
}
